if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer")) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
          this.submitButton.setAttribute("aria-expanded", "false");
        }
        this.statusElement = this.querySelector(".product-form__status");
        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        if (this.statusElement) this.statusElement.textContent = "";

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");
        this.querySelector(".product-form__submit-label")?.classList.add("hidden");
        this.querySelector(".product-form__submit-loading-text")?.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        formData.delete("selling_plan");

        // get id from formData
        const variantId = formData.get("id");
        // find select with matching data-variant-id
        const subscriptionSelect = this.closest("product-info")?.querySelector(
          `subscriptions-select[data-variant-id="${variantId}"] select`,
        );
        // if found, append selling_plan to formData
        if (subscriptionSelect) {
          const sellingPlanId = subscriptionSelect.value;
          if (sellingPlanId) {
            formData.append("selling_plan", sellingPlanId);
          }
        } else {
          formData.delete("selling_plan");
        }

        let productGroup = this.closest(".product")?.querySelector("product-group");

        if (productGroup) {
          let productGroupCurrent = productGroup.dataset.selectedType;
          let productGroupCurrentItem = productGroupCurrent.split(":");
          let productGroupType = productGroupCurrentItem[0].trim();
          let productGroupData = productGroupCurrentItem[1].trim();

          formData.set(`[properties][${productGroupType}]`, productGroupData);
        }

        const upsellSubscription = document.getElementById("subscription_true");

        if (upsellSubscription) {
          if (upsellSubscription.checked) {
            const upsellId = document.getElementsByName("upsell_id")[0].value;
            const upsellSellingPlan = document.getElementsByName("upsell_selling_plan")[0].value;

            formData.append("items[1][id]", upsellId);
            formData.append("items[1][quantity]", 1);
            formData.append("items[1][selling_plan]", upsellSellingPlan);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // Since items were likely added despite the error, fetch updated cart data
              if (this.cart && response.message) {
                // Get the sections we need to update
                const sectionsToRender = this.cart.getSectionsToRender();
                const sectionsUrl = new URL(window.location.pathname, window.location.origin);
                sectionsUrl.searchParams.set("sections", sectionsToRender.map((section) => section.id).join(","));

                fetch(sectionsUrl.href)
                  .then((response) => response.json())
                  .then((cartResponse) => {
                    // Transform the response to match the expected format
                    const formattedResponse = {
                      sections: cartResponse,
                    };
                    this.cart.renderContents(formattedResponse);
                  })
                  .catch((e) => {
                    console.error("Error fetching updated cart:", e);
                    window.location.reload();
                  });
              }

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form", productVariantId: formData.get("id") });
              if (this.statusElement) this.statusElement.textContent = this.statusElement.dataset.successText || "";
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            this.querySelector(".product-form__submit-label")?.classList.remove("hidden");
            this.querySelector(".product-form__submit-loading-text")?.classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
